//Sort of mimics a row in one of the input tables from the iPad app
const Description = ({ label }) => {

    return (
        <div className={'form-input-area__input-row'}>
            <p>{label}</p>
        </div>
    );
};

export default Description;
